import script from "./ContentItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentItem.vue?vue&type=script&setup=true&lang=ts"

import "./ContentItem.vue?vue&type=style&index=0&id=1048fd48&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/ClementRivaille.github.io/ClementRivaille.github.io/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1048fd48"]])

export default __exports__